import React from 'react';
import { ReactComponent as FolderIcon } from './../assets/folder-icon.svg';
import FormTextAreaField from '../../../postCreationForm/formTextAreaField/FormTextAreaField';
import './Comment.css';
import classNames from 'classnames';

const Comment = ({ values, touched, errors, name, placeholder, maxLength, handleChange }) => {
    const portfolioCommentTextAreaClass = classNames({
        portfolioComment: true,
        portfolioComment_small: !!values.comment,
    });

    const portfolioCommentClass = classNames({
        formFieldWrapper: true,
        formTextAreaWrapper: true,
        'portfolioComment-wrap': true,
        'field-error': errors.comment && touched.comment,
    });

    return (
        <div className="field-wrap">
            <div className="field-header">
                <FolderIcon />
                <div className="header-text">Any additional notes</div>
            </div>
            <div className={portfolioCommentClass}>
                <FormTextAreaField
                    handleChange={handleChange}
                    name={name}
                    values={values}
                    touched={touched}
                    errors={errors}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    className={portfolioCommentTextAreaClass}
                />
                <div className="portfolioComment__symbol-limit_wrap">
                    <div className="symbol-limit portfolioComment__symbol-limit">
                        {`${values.comment.length}/${maxLength}`}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Comment;
